var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5172 0.91408L0.224359 6.91573C-0.0665215 7.02997 -0.0771051 7.43765 0.207502 7.56665L3.58822 9.10022C3.67984 9.14182 3.74936 9.22027 3.77947 9.31626L5.22992 13.9303C5.30316 14.1632 5.58498 14.2536 5.78005 14.1067L8.30474 12.2054C8.4253 12.1146 8.59016 12.1103 8.71538 12.1947L12.9497 15.0502C13.1609 15.1925 13.4489 15.0718 13.4952 14.8213L15.9938 1.30699C16.0444 1.03423 15.7753 0.812261 15.5169 0.913712L15.5172 0.91408ZM6.25008 9.75486L5.79388 12.3473L4.61617 8.63524L12.6898 3.62608L6.25008 9.75486Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.254e117d.svg";
export { ForwardRef as ReactComponent };